import axios from "axios";
import store from "@/store";
import router from '@/router'

const generateInstance = (baseURL) => {
    const options = {
        baseURL,
        timeout: 3600 * 60,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
        }
    };
    const http = axios.create(options);

    http.defaults.withCredentials = true;
    
    const waitForStorageToBeReady = async (config) => {
        await store.restored
        const token = store.getters['auth/getToken'];
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    }
    
    // Add a request interceptor
    http.interceptors.request.use(
        config => waitForStorageToBeReady(config),
        requestError => {
            return Promise.reject(requestError);
        }
    );
    
    // Add a response interceptor
    http.interceptors.response.use(
        response => response,
        error => {
            if(error.response.status == 403){
                store.dispatch('logoutStorage')
                router.push({name: 'Login'})
            }
            return Promise.reject(error);
        }
    );
    return http
}

const client = {
    get api(){
        return generateInstance(process.env.VUE_APP_BASE_URL)
    },
    get admin(){
        return generateInstance(process.env.VUE_APP_ADMIN_URL)
    },
}


export default client;